<template>
  <el-popover
    v-model="visible"
    :placement="placement"
    :width="width"
    trigger="click"
  >
    <v-emoji-picker :emoji-size="25" @select="select" class="emoji-picker" />
    <el-button slot="reference">
      <span class="btn-icon">☺</span>
    </el-button>
  </el-popover>
</template>

<script>
import { VEmojiPicker } from 'v-emoji-picker'
export default {
  name: 'EmojiPicker',
  components: {
    VEmojiPicker
  },
  props: {
    placement: {
      type: String,
      default: 'bottom'
    },
    width: {
      type: [String, Number],
      default: '300'
    },
    onSelect: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    select(e) {
      this.onSelect(e)
      this.visible = false
    }
  }
}
</script>

<style scoped lang="scss">
.emoji-picker {
  background-color: #ffffff !important;
  margin: -13px;
  vertical-align: bottom;
}
/deep/ .container-emoji {
  height: 250px !important;
}
.btn-icon {
  display: table;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/common/components/EmojiPicker.vue